import { supabase } from '../../lib/supabase';

// public_institute_brand is a Phase 90 RPC not yet in the generated types
// (regen after applying the migration). Narrow through unknown so this file
// stays typecheck-clean without a codegen step. Anon may call it — the login
// page is public.
interface UnknownRpc {
  rpc: (
    fn: string,
    args?: Record<string, unknown>,
  ) => Promise<{ data: unknown; error: { message: string } | null }>;
}
const rpcUnknown = supabase as unknown as UnknownRpc;

export interface InstituteBrand {
  name: string;
}

/** Public display name for an ACTIVE institute by slug, or null if none. */
export async function getInstituteBrand(slug: string): Promise<InstituteBrand | null> {
  const { data, error } = await rpcUnknown.rpc('public_institute_brand', { p_slug: slug });
  if (error !== null) throw new Error(error.message);
  const rows = (data as InstituteBrand[] | null) ?? [];
  return rows[0] ?? null;
}
